module.exports = __webpack_public_path__ + "img/maqiang.b229ebfe.jpg";